module.exports = Jsw.skinUrl + "/icons/16/plesk/file-image.png?1327e17a096bce2f49ad2f66f4abdaf6";